import { PerformanceViewModel, defaultPerformanceModel, IProductionModels, defaultProductionModels } from './classes';
import { ActionTypes } from './actions';
import * as _ from 'lodash';


export interface IDirectoryStateAction { 
    type: ActionTypes;
    value?: any;
}


export function reduce(state: IProductionModels = defaultProductionModels, action: IDirectoryStateAction) {
    switch (action.type) {
        case ActionTypes.AddPerformance: {
            var updatedState = state.performanceModels.concat(action.value) 
            return _.assign({}, state, { performanceModels: updatedState }) as IProductionModels;
        }
        case ActionTypes.LoadPerformance: {
            return _.assign({}, state, action.value) as IProductionModels;
        }
    }
}